import { render, staticRenderFns } from "./LogOutIcon.vue?vue&type=template&id=4bfa1af5&"
import script from "./LogOutIcon.vue?vue&type=script&lang=js&"
export * from "./LogOutIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports